export default {"src":"/_next/static/media/ic-blog.509e1f74.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};